
(function () {
    'use strict';

    angular.module(modules.homeModule)
        .controller('NewsDetailsController', newsDetailsController);

    newsDetailsController.$inject = ['$stateParams', '$sce', '$timeout',
        'newsService', 'anchorService', 'resizeService'];

    function newsDetailsController($stateParams, $sce, $timeout,
        newsService, anchorService, resizeService) {
        var vm = this;

        vm.news = null;
        vm.id = $stateParams.newsId;
        vm.translation = {
            attachments: globalResources.CommonGridColumns.HasAttachment,
            editNews: globalResources.EditNews
        };
        vm.GetFileRequest = handbookRequests.GetFileRequest;
        vm.linkToEditNewsView = linkToEditNewsView;

        vm.copyUserFriendlyUrlTooltip = globalResources.CopyUserFriendlyUrl;


        initialize();

        vm.urlNews = window.location.origin + '/news/' + vm.id;

        function initialize() {
            resizeService.resizeView();
            getNewsById(vm.id);
        };

        function getNewsById(id) {
            newsService
                .getActiveNewsById(id)
                .then(function (result) {
                    vm.news = result.data;
                    if (vm.news !== null && vm.news.image !== null) {
                        newsService
                            .getNewsImageById(vm.news.id)
                            .then(function (result) {
                                if (result.data !== null && result.data.value !== null) {
                                    if (result.data.id === -1) {
                                        vm.news.image.value = result.data.value;
                                    }
                                    else {
                                        vm.news.image.value = 'data:image/png;base64,' + result.data.value;
                                    }
                                }
                            });
                    }
                    vm.news.body = $sce.trustAsHtml(vm.news.body);
                    runServicesAfterInit();
                })
        };

        function runServicesAfterInit() {
            $timeout(function () {
                updateLocalAnchors();
            }, 500);
        }

        function updateLocalAnchors() {
            var domContent = angular.element('div.news-detail-body');
            anchorService.updateLocalAnchors(domContent);
        }

        function linkToEditNewsView() {
            var backendUrl = HandbookConfiguration.BackendURL;
            var lastChar = backendUrl.charAt(backendUrl.length - 1);
            var commonAdd = lastChar == '/' ? '' : '/';

            var url = backendUrl + commonAdd + 'admin/newsCategories/' + vm.news.categoryId + '/' + vm.id + '/edit';
            window.open(url, '_blank');

        }
    };
})();

